/**
 * Theme Switcher
 * Manages color scheme switching (default/alternative) with localStorage persistence
 */

class ThemeSwitcher {
  constructor() {
    this.storageKey = 'zs2-color-scheme';
    this.defaultTheme = 'style1';
    this.themes = ['style1', 'style2'];

    this.init();
  }

  init() {
    // Load saved theme or use default
    const savedTheme = this.getSavedTheme();
    this.setTheme(savedTheme);
  }

  getSavedTheme() {
    const saved = localStorage.getItem(this.storageKey);
    return saved && this.themes.includes(saved) ? saved : this.defaultTheme;
  }

  setTheme(theme) {
    if (!this.themes.includes(theme)) {
      console.warn(`Unknown theme: ${theme}`);
      return;
    }

    // Set HTML attribute for CSS to use
    if (theme === this.defaultTheme) {
      document.documentElement.removeAttribute('data-theme');
    } else {
      document.documentElement.setAttribute('data-theme', theme);
    }

    // Update SVG fill colors
    this.updateSvgColors(theme);

    // Save preference
    localStorage.setItem(this.storageKey, theme);

    // Dispatch custom event for other listeners
    window.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
  }

  updateSvgColors(theme) {

  }

  toggleTheme() {
    const current = this.getCurrentTheme();
    const next = current === this.defaultTheme ? 'style2' : this.defaultTheme;
    this.setTheme(next);
    return next;
  }

  getCurrentTheme() {
    return document.documentElement.getAttribute('data-theme') || this.defaultTheme;
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.themeSwitcher = new ThemeSwitcher();
  });
} else {
  window.themeSwitcher = new ThemeSwitcher();
}
